import React, { Fragment } from "react";
import PropTypes from "prop-types";

const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : "");

const TONES = {
	success: "bg-success-soft text-success",
	warning: "bg-warning-soft text-warning",
	danger: "bg-danger-soft text-danger",
	info: "bg-primary-soft text-primary-hover",
	neutral: "bg-surface-2 text-text-2",
};

const STATUS_TONE = {
	defined: "success", success: "success", approved: "success", compliant: "success",
	incomplete: "warning", "no steps": "warning", "no roles": "warning",
	"needs attention": "warning", running: "warning", awaiting: "warning", warning: "warning",
	failed: "danger", rejected: "danger", danger: "danger",
	stopped: "info", delegated: "info", info: "info",
	pending: "neutral", cancelled: "neutral", expired: "neutral", queued: "neutral", neutral: "neutral",
};

const Badge = ({ status, label, size }) => {
	const value = label != null ? label : cap(status);
	let tone = "neutral";
	if (status && /^\d+ (steps|assigned)$/.test(status)) tone = "success";
	else if (status && STATUS_TONE[status]) tone = STATUS_TONE[status];

	const sizeCls = size === "sm"
		? "text-xs px-2 py-0 min-w-0"
		: "text-sm px-2.5 py-0.5 min-w-[65px]";

	return (
		<Fragment>
			<div className={`inline-block text-center rounded-full font-medium cursor-default ${TONES[tone]} ${sizeCls}`}>
				{value}
			</div>
		</Fragment>
	);
};

Badge.propTypes = {
	status: PropTypes.string,
	label: PropTypes.string,
	size: PropTypes.oneOf(["sm"]),
};

export default Badge;
